



























import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import LinkButtonIcon from '@/components/atoms/LinkButtonIcon.vue';
import LinkMenuLink from '@/components/molecules/LinkMenuLink.vue';
import { ID, LinkMenu } from '@/types/type';

@Component({
  components: { LinkMenuLink, LinkButtonIcon },
})
export default class LinkButtons extends Vue {
  @Prop()
  private menus!: LinkMenu[];

  @Emit('link-opened')
  private linkOpened(id: ID): ID {
    return id;
  }
}
